import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { AboutService } from '../../../services/about.service';
import { AboutData } from '../../../interfaces/about.interface';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  loading = true;
  error = false;
  aboutData: AboutData | null = null;

  constructor(
    private titleService: Title, 
    private metaService: Meta,
    private aboutService: AboutService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.loadAboutData();
  }

  private loadAboutData(): void {
    this.loading = true;
    this.error = false;

    this.aboutService.getAboutData().subscribe({
      next: (data) => {
        this.aboutData = data;
        this.loading = false;
        this.updateMetaTags(data.metaTags);
      },
      error: (err) => {
        console.error('Error loading about data:', err);
        this.error = true;
        this.loading = false;
      }
    });
  }

  private updateMetaTags(metaTags: any[]): void {
    // Remove existing meta tags
    this.metaService.removeTag("name='description'");
    this.metaService.removeTag("name='keywords'");
    this.metaService.removeTag("name='author'");
    this.metaService.removeTag("property='og:title'");
    this.metaService.removeTag("property='og:description'");
    this.metaService.removeTag("property='og:image'");
    this.metaService.removeTag("property='og:url'");
    this.metaService.removeTag("property='og:type'");
    this.metaService.removeTag("name='twitter:card'");
    this.metaService.removeTag("name='twitter:title'");
    this.metaService.removeTag("name='twitter:description'");
    this.metaService.removeTag("name='twitter:image'");
    this.metaService.removeTag("rel='canonical'");

    // Add new meta tags
    metaTags.forEach(tag => {
      if (tag.name === 'title') {
        this.titleService.setTitle(tag.content);
      } else if (tag.charset) {
        this.metaService.updateTag({ charset: tag.charset });
      } else if (tag['http-equiv']) {
        this.metaService.updateTag({ 'http-equiv': tag['http-equiv'], content: tag.content });
      } else if (tag.rel === 'canonical') {
        this.metaService.updateTag({ rel: 'canonical', href: tag.href });
      } else {
        const metaTag: any = {};
        if (tag.name) metaTag.name = tag.name;
        if (tag.property) metaTag.property = tag.property;
        if (tag.content) metaTag.content = tag.content;
        this.metaService.updateTag(metaTag);
  }
    });
  }
}




